module.exports = " <div class=\"select select-full\" :class=\"{ 'select--active': isActive }\" :data-content=label> <select v-el:select :name=name v-model=data tabindex=0 @focus=\"isActive = true\" @blur=\"isActive = false\"> <option v-for=\"option in selectOptions\" :value=option.value>{{ option.text }}</option> </select> </div> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/fieldtypes/SelectFieldtype.vue
// module id = 736
// module chunks = 0